import { Result } from 'src/app/shared/class/result.model';
import { Parent } from 'src/app/shared/class/parent.model';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { User } from '../../shared/class/user.model';
import { AuthService } from '../../services/auth.service'
import pageSettings from '../../config/page-settings';
import { Router } from '@angular/router';
import { SharedService } from 'src/app/shared/shared.service';
import { UsuarioPersonal } from 'src/app/projects/personal/accesos/accesos-class/accesos.model';
import { AccesosService } from 'src/app/projects/personal/accesos/accesos.service';
import * as moment from 'moment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [AuthService]
})
export class LoginComponent extends Parent implements OnInit, OnDestroy {

  pageSettings = pageSettings;
  public anio: number = moment().year();
  public formGroup: FormGroup;
  private uid: string = null;

  constructor(
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private renderer: Renderer2,
    private sharedService: SharedService,
    private accesosService: AccesosService,
    private router: Router
  ) {
    super();
    this.pageSettings.pageEmpty = true;
    this.renderer.addClass(document.body, 'bg-white');
  }

  ngOnInit() {
    this.buildForm();
  }

  ngOnDestroy() {
    this.pageSettings.pageEmpty = false;
    this.renderer.removeClass(document.body, 'bg-white');
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      email: [null, Validators.required],
      password: [null, Validators.required]
    });
  }

  onLogin(user: User) {
    this.accesosService.login(user.email, user.password)
      .subscribe((result: Result) => {
        if (result.success) {
          this.usuario = <UsuarioPersonal>result.data;
          this.uid = JSON.stringify(this.usuario.uid);
          sessionStorage.setItem('uid', JSON.stringify(this.uid));
          sessionStorage.setItem('usuario', JSON.stringify(this.usuario));
          sessionStorage.setItem('nombreUsuario', JSON.stringify(this.usuario.nombre));
          window.location.href = '/home/personal';
        } else {
          this.mensajePopup.alertaValidacion(false, 'LO SENTIMOS!!', result.msg);
          sessionStorage.clear();
          localStorage.clear();
          window.location.href = '/login';
        }
      });
  }

  /* onLogin(user: User) {
    this.authService.loginByEmail(user)
      .then(res => {
        console.log(res);
        window.location.href = '/home';
        if (res.user.uid) {
          this.uid = JSON.stringify(res.user.uid);
          localStorage.setItem('uid', JSON.stringify(res.user.uid));
          this.getAccesos();
          window.location.href = '/home';
        } else {
          window.location.href = '/login';
        }
      })
      .catch(err => {
        localStorage.clear();
        window.location.href = '/login';
      });
  } */

  getAccesos() {
    this.showProcessing = true;
    this.uid = <string>JSON.parse(sessionStorage.getItem('uid'));
    this.sharedService.getUsuarioPersonal(this.uid)
      .subscribe((result: Result) => {
        if (result.success) {
          this.showProcessing = false;
          const usuario = <UsuarioPersonal>result.data;
          if (usuario) {
            localStorage.setItem('usuario', JSON.stringify(usuario));
            localStorage.setItem('nombreUsuario', JSON.stringify(usuario.nombre));
          } else {
            this.mensajePopup.alertaNotificacion('INFO', 'El usuario no tiene accesos', 'info');
          }
        }
      }, (err) => {
        this.showProcessing = false;
      });
  }

}
